import { render, staticRenderFns } from "./HappinessWidget.vue?vue&type=template&id=ae49ffca&scoped=true&"
import script from "./HappinessWidget.vue?vue&type=script&lang=js&"
export * from "./HappinessWidget.vue?vue&type=script&lang=js&"
import style0 from "./HappinessWidget.vue?vue&type=style&index=0&id=ae49ffca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae49ffca",
  null
  
)

export default component.exports